// =====================================================
// BusinessActionRow.jsx Save (♥) + Share row  (v2)
// v2: all CSS classes renamed to ghfav-* so they cannot
// collide with existing site styles.
//
// Usage:
//   <BusinessActionRow
//     businessId={biz.id}
//     businessName={biz.name}
//   />
// Optional: compact  (icon-only, for tight cards)
// =====================================================

import React, { useRef, useState } from "react";
import {
  FaHeart,
  FaRegHeart,
  FaShareAlt,
  FaCheck,
} from "react-icons/fa";
import { useFavorites } from "./FavoritesContext";
import "./Favorites.css";

export default function BusinessActionRow({
  businessId,
  businessName = "",
  compact = false,
}) {
  const { isSaved, toggleSave } = useFavorites();
  const [justShared, setJustShared] = useState(false);
  const sharedTimer = useRef(null);

  const saved = isSaved(businessId);

  const handleShare = async () => {
    const url = window.location.href;
    const title = businessName
      ? `${businessName} on GoOurHub`
      : "Found on GoOurHub";

    try {
      if (navigator.share) {
        await navigator.share({ title, url });
        return;
      }

      await navigator.clipboard.writeText(url);
      setJustShared(true);
      clearTimeout(sharedTimer.current);
      sharedTimer.current = setTimeout(
        () => setJustShared(false),
        2000
      );
    } catch {
      /* user closed the share sheet nothing to do */
    }
  };

  return (
    <div
      className={`ghfav-row ${
        compact ? "ghfav-row--compact" : ""
      }`}
    >
      <button
        type="button"
        className={`ghfav-btn ${saved ? "is-saved" : ""}`}
        onClick={() => toggleSave(businessId, businessName)}
        aria-pressed={saved}
        aria-label={
          saved
            ? `Remove ${businessName || "business"} from saved`
            : `Save ${businessName || "business"}`
        }
      >
        {saved ? (
          <FaHeart aria-hidden="true" />
        ) : (
          <FaRegHeart aria-hidden="true" />
        )}
        {!compact && <span>{saved ? "Saved" : "Save"}</span>}
      </button>

      <button
        type="button"
        className="ghfav-btn"
        onClick={handleShare}
        aria-label={`Share ${businessName || "business"}`}
      >
        {justShared ? (
          <FaCheck aria-hidden="true" />
        ) : (
          <FaShareAlt aria-hidden="true" />
        )}
        {!compact && (
          <span>{justShared ? "Link copied" : "Share"}</span>
        )}
      </button>

      {/*
        Coming next, same pattern:
        <button className="ghfav-btn">Follow</button>       (Phase 2)
        <button className="ghfav-btn">Write review</button> (Phase 1b)
      */}
    </div>
  );
}
